(function () {
	const activate = (menu, tab) => {
		const id = tab.dataset.tab
		menu.querySelectorAll('.mega-visual__tab').forEach((item) => {
			const isActive = item === tab
			item.classList.toggle('is-active', isActive)
			item.setAttribute('aria-selected', isActive ? 'true' : 'false')
		})
		menu.querySelectorAll('.mega-visual__panel').forEach((panel) => {
			panel.hidden = panel.dataset.tab !== id
		})
	}

	const init = (root) => {
		root.querySelectorAll('[data-mega-visual]').forEach((menu) => {
			if (menu.dataset.mvReady) return
			menu.dataset.mvReady = 'true'
			const openOnHover = menu.dataset.open !== 'click'

			menu.querySelectorAll('.mega-visual__tab').forEach((tab) => {
				tab.addEventListener('click', (event) => {
					// Bağlantılı sekmede ilk dokunuş sekmeyi açar, ikincisi sayfaya gider
					if (tab.tagName === 'A' && !tab.classList.contains('is-active')) {
						event.preventDefault()
					}
					activate(menu, tab)
				})
				tab.addEventListener('focus', () => activate(menu, tab))
				if (openOnHover) {
					tab.addEventListener('mouseenter', () => activate(menu, tab))
				}
			})
		})
	}

	const updateArrows = (panel) => {
		const row = panel.querySelector('.mega-visual__grid--row')
		if (!row) return
		const max = row.scrollWidth - row.clientWidth - 2
		panel.querySelectorAll('[data-mv-scroll]').forEach((arrow) => {
			arrow.disabled = arrow.dataset.mvScroll === '-1' ? row.scrollLeft <= 0 : row.scrollLeft >= max
		})
	}

	document.addEventListener('click', (event) => {
		const arrow = event.target.closest && event.target.closest('[data-mv-scroll]')
		if (!arrow) return
		const panel = arrow.closest('.mega-visual__panel')
		const row = panel && panel.querySelector('.mega-visual__grid--row')
		if (!row) return
		row.scrollBy({ left: Number(arrow.dataset.mvScroll) * row.clientWidth * 0.8 })
	})

	document.addEventListener('scroll', (event) => {
		const row = event.target
		if (row.classList && row.classList.contains('mega-visual__grid--row')) {
			updateArrows(row.closest('.mega-visual__panel'))
		}
	}, true)

	// Panel görünür olunca okların durumunu güncelle (gizliyken genişlik ölçülemez)
	document.addEventListener('mouseover', (event) => {
		const menu = event.target.closest && event.target.closest('[data-mega-visual]')
		if (menu) menu.querySelectorAll('.mega-visual__panel:not([hidden])').forEach(updateArrows)
	})

	init(document)

	document.addEventListener('shopify:section:load', (event) => init(event.target))

	document.addEventListener('shopify:block:select', (event) => {
		const menu = event.target.closest ? event.target.closest('[data-mega-visual]') : null
		document.querySelectorAll('.mega-visual.is-editor-open').forEach((open) => open.classList.remove('is-editor-open'))
		if (menu) menu.classList.add('is-editor-open')
	})

	document.addEventListener('shopify:block:deselect', () => {
		document.querySelectorAll('.mega-visual.is-editor-open').forEach((open) => open.classList.remove('is-editor-open'))
	})
})()
